import api from './api';

const base = (tenantId) => `/api/harvesting/${tenantId}`;

// ── Taxonomy ────────────────────────────────────────────────────────────────
export const getCategories = (tenantId) =>
  api.get(`${base(tenantId)}/categories`);

export const getHarvestConfig = (tenantId) =>
  api.get(`${base(tenantId)}/config`);

export const updateHarvestConfig = (tenantId, data) =>
  api.put(`${base(tenantId)}/config`, data);

// ── Assisted participant intake and one-time handovers ──────────────────────
export const searchHarvestParticipants = (tenantId, q) =>
  api.get(`${base(tenantId)}/participants/search`, { params: { q } });

export const createHarvestParticipant = (tenantId, data) =>
  api.post(`${base(tenantId)}/participants`, data);

export const submitAssistedGuidedHarvest = (tenantId, data) =>
  api.post(`${base(tenantId)}/records/assisted-guided`, data);

export const issueParticipantInvite = (tenantId, participantId, data) =>
  api.post(`${base(tenantId)}/participants/${participantId}/invitations`, data);

export const issueParticipantRecovery = (tenantId, participantId, data) =>
  api.post(`${base(tenantId)}/participants/${participantId}/recovery`, data);

export const completeParticipantClaim = (data) =>
  api.post('/api/harvesting/claim', data);

export const completeParticipantRecovery = (data) =>
  api.post('/api/harvesting/recovery/complete', data);

// ── Stats (reviewer) ────────────────────────────────────────────────────────
export const getStats = (tenantId) =>
  api.get(`${base(tenantId)}/stats`);

// ── Platform-wide stats (platform staff / admin only) ───────────────────────
export const getPlatformStats = () =>
  api.get('/api/harvesting/platform-stats');

// ── Record listing ──────────────────────────────────────────────────────────
export const getRecords = (tenantId, params) =>
  api.get(`${base(tenantId)}/records`, { params });

export const getMyRecords = (tenantId, params) =>
  api.get(`${base(tenantId)}/records/mine`, { params });

export const getRecord = (tenantId, id) =>
  api.get(`${base(tenantId)}/records/${id}`);

// ── Record mutation ─────────────────────────────────────────────────────────
export const submitRecord = (tenantId, data) =>
  api.post(`${base(tenantId)}/records`, data);

export const submitGuidedHarvest = (tenantId, data) =>
  api.post(`${base(tenantId)}/records/guided`, data);

export const updateRecord = (tenantId, id, data) =>
  api.patch(`${base(tenantId)}/records/${id}`, data);

export const deleteRecord = (tenantId, id) =>
  api.delete(`${base(tenantId)}/records/${id}`);

export const setRecordFlags = (tenantId, id, flags) =>
  api.patch(`${base(tenantId)}/records/${id}/flags`, { flags });

export const addRecordNote = (tenantId, id, text) =>
  api.post(`${base(tenantId)}/records/${id}/notes`, { text });
